export default {
      id: "update-usage",
      viewBox: "0 0 13 12",
      url: __webpack_public_path__ + "sprite-46b249.svg#update-usage",
      toString: function () {
        return this.url;
      }
    }